export default __webpack_public_path__ + "2d4178ff803a3954ae92fc43687ac512.ttf";